import styled from 'styled-components';
import { Container } from '~/components/layout';
import { FlexTheme } from '~/styles/theme';

export type BackgroundOption = keyof FlexTheme['colors']['background'];

export const CalloutContainer = styled(Container)<{ background: BackgroundOption }>`
  background-color: ${props => props.theme.colors.background[props.background]};
  border-radius: ${props => props.theme.space[2]}px;
  display: flex;
  padding: ${props => props.theme.space[4]}px;
`;
